export const removeEmptyStringsFromObj = (obj: unknown) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === "") {
      delete obj[key];
    }
  });
};
